$(window).ready(() => {
    $('[data-fullScreen],[data-fullScreen-full]').on('click', function(event) {
        let video = $(this).parents("[class*='video']").find('video').get(0);

        if (navigator.userAgent.match(/iPhone/i)
        ) {
            video.webkitEnterFullscreen();
        }

        video.requestFullscreen();
    });
});
